document.addEventListener('DOMContentLoaded', function() {
    const precios = document.querySelectorAll('.price-item--last, .price-item--regular, .precioNormal-fixedSection');

    precios.forEach(function(precioElemento) {
        const textoOriginal = precioElemento.textContent;

        if (!textoOriginal || textoOriginal.trim() === '') {
        return; 
        }

        let textoPrecio = textoOriginal.replace('.', ',');
        const partes = textoPrecio.split(',');

        if (partes.length === 2) {
        const parteEntera = partes[0];
        const parteDecimal = partes[1];

        precioElemento.innerHTML = `${parteEntera},<span class="precio-decimales">${parteDecimal}</span>`;
        }
    });
});